import { Outlet } from 'react-router-dom';

import { PageSettings } from './components/page';
import { AgentProvider, useAgent } from './context/agent';

const Content = () => {
  const agent = useAgent();
  return agent ? (
    <PageSettings>
      <Outlet />
    </PageSettings>
  ) : null;
};

export const Component = () => {
  return (
    <AgentProvider>
      <Content />
    </AgentProvider>
  );
};
